import React, { useState } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import withBackSupport from 'components/HOCs/withBackSupport';
import { LoginContext } from './LoginContext';
import BaseLoginPage from './BaseLoginPage';
import EmailPage from './EmailPage';
import PasswordPage from './PasswordPage';

const LoginRoutes = ({ match }) => {
  const [email, setEmail] = useState('');
  return (
    <BaseLoginPage>
      <LoginContext.Provider value={{ email, setEmail }}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/email`} />
          <Route exact path={`${match.url}/email`} component={EmailPage} />
          <Route exact path={`${match.url}/*/password`} component={PasswordPage} />
        </Switch>
      </LoginContext.Provider>
    </BaseLoginPage>
  );
};

export default withBackSupport(LoginRoutes);
